module.exports = __webpack_public_path__ + "img/lk.ae571af0.svg";